import React, { useMemo, useState } from "react";
import { Calendar, Clock, Zap, CheckCircle, XCircle, MoreHorizontal, MessageSquare, Edit, Download, FileText } from "lucide-react";
import PageHeader from "../common/PageHeader";
import fetchData from "../../api/fetchApi";
import { useNavigate } from "react-router-dom";

// Helper for status pills
const StatusPill = ({ text, color, icon }) => {
  const colors = {
    purple: "bg-purple-100 text-purple-700",
    green: "bg-green-100 text-green-700",
    red: "bg-red-100 text-red-700",
  };
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs px-2 py-1 rounded-full ${colors[color]}`}>
      {icon}
      {text}
    </span>
  );
};

// Card component to handle its own state
const ConsultationCard = ({ consultation, type }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showReplyModal, setShowReplyModal] = useState(false);
  const [replyText, setReplyText] = useState("");
  const [replyLoading, setReplyLoading] = useState(false);
  const [replyError, setReplyError] = useState(null);
  const navigate = useNavigate();

 

  const renderFooter = () => {
    if (isExpanded) {
      return (
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 text-xs text-gray-500">
            <Calendar size={14} /> {consultation.date}
          </div>
          <button onClick={() => setIsExpanded(false)} className="text-sm text-gray-500">
            إخفاء التفاصيل
          </button>
        </div>
      );
    }

    switch (type) {
      case 'pending':
        return (
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 text-xs text-gray-500">
              <Calendar size={14} /> {consultation.date}
            </div>
            <div className="flex items-center gap-2">
              <button onClick={() => setIsExpanded(true)} className="px-4 py-2 text-sm rounded-lg border border-gray-300 bg-gray-100 text-[#1D2035]">عرض التفاصيل</button>
              <button
                className="px-4 py-2 text-sm rounded-lg text-white bg-[var(--Primary-Primary)] flex items-center gap-2"
                onClick={async () => {
                  try {
                    await fetchData(`consultation/assign?uuid=${consultation.uuid}`, "PUT");
                  } catch (err) {
                    alert("فشل تعيين الاستشارة");
                  }
                }}
              >
                <MessageSquare size={16} /> الرد على الاستشارة
              </button>
            </div>
          </div>
        );
      case 'inProgress':
        return (
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 text-xs text-gray-500">
              <Calendar size={14} /> {consultation.date}
              <StatusPill text="تم الرد" color="green" icon={<CheckCircle size={12} />} />
            </div>
            <button className="px-4 py-2 text-sm rounded-lg text-white bg-green-600 flex items-center gap-2" onClick={() => {
              navigate(`/admin/legal-consultations/reply/${consultation.uuid}`);
            }}>
              <Edit size={16} /> استكمال الرد
            </button>
            {/* {showReplyModal && (
              <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
                <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-md">
                  <h3 className="text-lg font-bold mb-4">إرسال رد جديد</h3>
                  <form onSubmit={handleReplySubmit} className="space-y-4">
                    <textarea
                      className="w-full border rounded-lg p-2"
                      rows={4}
                      value={replyText}
                      onChange={e => setReplyText(e.target.value)}
                      placeholder="اكتب الرد هنا..."
                      required
                    />
                    {replyError && <div className="text-red-600 text-sm">{replyError}</div>}
                    <div className="flex gap-2 justify-end mt-4">
                      <button type="button" className="px-4 py-2 rounded bg-gray-200" onClick={() => setShowReplyModal(false)}>إلغاء</button>
                      <button type="submit" className="px-4 py-2 rounded bg-green-600 text-white" disabled={replyLoading}>{replyLoading ? 'جاري الإرسال...' : 'إرسال'}</button>
                    </div>
                  </form>
                </div>
              </div>
            )} */}
          </div>
        );
      case 'closed':
        return (
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 text-xs text-gray-500">
              <Calendar size={14} /> {consultation.date}
            </div>
            <button onClick={() => setIsExpanded(true)} className={`w-full mt-4 px-4 py-2 text-sm rounded-lg flex items-center justify-center gap-2 ${isExpanded ? 'bg-gray-100 text-gray-500 border-gray-200' : 'bg-gray-100 text-gray-500 border border-gray-200'}`}>
              <CheckCircle size={16} /> تم اغلاق الاستشارة بنجاح
            </button>
          </div>
        );
       case 'closed-final':
        return (
            <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 text-xs text-gray-500">
                <Calendar size={14} /> {consultation.date}
            </div>
            <button 
                onClick={() => setIsExpanded(true)} 
                className="w-full mt-4 px-4 py-2 text-sm rounded-lg flex items-center justify-center gap-2 border-2 border-blue-500 text-blue-600 bg-blue-50"
            >
                <CheckCircle size={16} /> تم اغلاق الاستشارة بنجاح
            </button>
            </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-4 flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 font-semibold text-[#1D2035]">
          <Zap size={18} className="text-gray-400" /> {consultation.title}
        </div>
        {type === 'inProgress' ? (
          <span className="text-xs bg-red-100 text-red-700 px-2 py-1 rounded-md flex items-center gap-1">
            <Clock size={12} /> {consultation.timer}
          </span>
        ) : (
          <StatusPill text={consultation.status.text} color={consultation.status.color} icon={consultation.status.icon} />
        )}
      </div>
      <div className="text-xs text-gray-500">{consultation.sub}</div>

      {isExpanded && (
        <div className="border-t border-b border-gray-100 my-2 py-4 flex flex-col gap-4">
          {consultation.payment && (
            <div className="text-xs text-gray-500">
              تم الدفع باستخدام {consultation.payment.method} ****{consultation.payment.last4}
              <img src="/visa.png" alt="visa" className="inline-block h-4 ml-2" />
            </div>
          )}
          {consultation.file && (
            <div className="flex items-center justify-between p-3 rounded-lg bg-gray-50 border">
              <div className="flex items-center gap-3">
                <FileText size={24} className="text-red-500" />
                <div>
                  <div className="font-semibold text-sm text-[#1D2035]">ملفات مهمة</div>
                  <div className="text-xs text-gray-500">{consultation.file.size} . {consultation.file.type}</div>
                </div>
              </div>
              <button className="p-2 rounded-full bg-white border shadow-sm">
                <Download size={18} className="text-gray-600" />
              </button>
            </div>
          )}
          {consultation.question && (
            <div>
              <h4 className="font-semibold text-sm mb-2 text-[#1D2035]">السؤال</h4>
              <p className="text-sm text-gray-600 leading-relaxed">{consultation.question}</p>
              {consultation.isPersonal && (
                 <div className="mt-3 text-sm text-amber-600 bg-amber-50 border border-amber-200 rounded-lg p-2 flex items-center gap-2">
                    <span>🙋‍♂️</span>
                    استشارة شخصية
                 </div>
              )}
            </div>
          )}
        </div>
      )}

      {renderFooter()}
    </div>
  );
};


// Main component
export default function LegalConsultationsPage() {

  const dir = "rtl";
  const [consultations, setConsultations] = useState({ pending: [], inProgress: [], closed: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dateRange] = useState({ from: "يناير 2025", to: "يونيو 2025" });

  const miniStats = useMemo(() => [
    { title: "تم الإنجاز", value: consultations.inProgress.length, delta: +4.9, status: "تم الرد", color: "green" },
    { title: "في الانتظار", value: consultations.pending.length, delta: +3.5, status: "في الانتظار", color: "purple" },
    { title: "تم الإغلاق", value: consultations.closed.length, delta: +2.3, status: "مغلقه", color: "red" },
  ], [consultations]);

  const normalizeConsultation = (item, type) => {
    const statusMap = {
      pending: { text: "في الانتظار", color: "purple", icon: <Clock size={12} /> },
      inProgress: { text: "تم الرد", color: "green", icon: <CheckCircle size={12} /> },
      closed: { text: "مغلقه", color: "red", icon: <XCircle size={12} /> },
    };
    return {
      uuid: item.uuid,
      title: item.title,
      sub: item.topic?.name || "استشارة",
      date: new Date(item.created_at).toLocaleDateString('ar-EG'),
      status: statusMap[type],
      question: item.body,
      files: item.files,
      payment: null,
      file: item.files?.length > 0 ? { name: "ملفات مرفقة", type: "Multiple", size: `${item.files.length} files` } : null,
      isPersonal: true,
      timer: "02:33",
    };
  };

  React.useEffect(() => {
    const loadConsultations = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetchData('admin/consultations');
        setConsultations({
          pending: (res.open || []).map(c => normalizeConsultation(c, 'pending')),
          inProgress: (res.assigned || []).map(c => normalizeConsultation(c, 'inProgress')),
          closed: (res.closed || []).map(c => normalizeConsultation(c, 'closed')),
        });
      } catch (err) {
        setError("فشل في تحميل الاستشارات. الرجاء المحاولة مرة أخرى.");
      } finally {
        setLoading(false);
      }
    };
    loadConsultations();
  }, []);

  // const closedFinal = {
  //   title: "كيف يمكنني الحفاظ على حقوق عند بيع ال...",
  //   sub: "توقيت الرد على الاستشارة",
  //   date: "01/04/2023 - 12/10/2022",
  //   status: { text: "مغلقه", color: "red", icon: <XCircle size={12} /> },
  // };

  return (
    <div className="min-h-screen p-4 md:p-6 bg-white" dir={dir}>
      {/* Header */}
        <PageHeader title="إجمالي الاستشارات القانونية"
               total={111} stats={[]}>
                    <button className="px-3 py-2 rounded-lg border border-gray-200 bg-white text-sm text-[#1D2035] flex items-center gap-2">
                         <span className="inline-block rotate-180">↕</span>
                         من الاحدث إلى الأقدم
                       </button>
                       <button className="px-3 py-2 rounded-lg border border-gray-200 bg-white text-sm text-[#1D2035] flex items-center gap-2">
                         <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                           <rect
                             x="3"
                             y="4"
                             width="18"
                             height="18"
                             rx="2"
                             stroke="#6b7280"
                           />
                           <line x1="8" y1="2" x2="8" y2="6" stroke="#6b7280" />
                           <line x1="16" y1="2" x2="16" y2="6" stroke="#6b7280" />
                           <line x1="3" y1="10" x2="21" y2="10" stroke="#6b7280" />
                         </svg>
                         {dateRange.from} · {dateRange.to}
                       </button>
                      
                     </PageHeader  >
      {/* Mini stats cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4 my-5">
        {miniStats.map((s, idx) => (
          <div key={idx} className="rounded-2xl border border-gray-200 bg-[#fafafa] p-3 md:p-4">
            <div className="flex items-start justify-between">
              <div className="text-sm text-[#1D2035]">{s.title}</div>
              <button className="w-8 h-8 grid place-items-center rounded-lg bg-white text-gray-500">
                <MoreHorizontal size={20} />
              </button>
            </div>
            <div className="mt-3 flex items-end justify-between">
              <div>
                <div className="text-2xl font-semibold text-[#1D2035]">{s.value.toLocaleString()}</div>
                <div className="text-[11px] text-gray-500 mt-1">
                  <StatusPill text={s.status} color={s.color} icon={s.color === 'green' ? <CheckCircle size={12}/> : s.color === 'red' ? <XCircle size={12}/> : <Clock size={12}/>} />
                </div>
              </div>
              <div className="text-[11px] text-gray-500 text-left">
                <div className="mb-1">من الشهر الماضي</div>
                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-green-50 text-green-700 border border-green-200">
                  <Zap size={12} className="transform scale-x-[-1]" />
                  +{s.delta}%
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Consultations Grid */}
      <div className="grid grid-cols-1 mt-2 lg:grid-cols-3 gap-5">
        {/* Column 1: Pending */}
        <div className="flex flex-col gap-5">
          <div className="flex items-center justify-between">
            <h3 className="font-semibold text-[#1D2035]">في الانتظار</h3>
            <span className="text-sm text-gray-400">{consultations.pending.length} استشارات</span>
          </div>
          {consultations.pending.map((c, i) => (
            <ConsultationCard key={`pending-${i}`} consultation={c} type="pending" />
          ))}
        </div>

        {/* Column 2: In Progress */}
        <div className="flex flex-col gap-5">
          <div className="flex items-center justify-between">
            <h3 className="font-semibold text-[#1D2035]">جاري الرد</h3>
            <span className="text-sm text-gray-400">{consultations.inProgress.length} استشارة</span>
          </div>
          {consultations.inProgress.map((c, i) => (
            <ConsultationCard key={`progress-${i}`} consultation={c} type="inProgress" />
          ))}
        </div>
        
        {/* Column 3: Closed */}
        <div className="flex flex-col gap-5">
          <div className="flex items-center justify-between ">
            <h3 className="font-semibold text-[#1D2035]">تم الاغلاق</h3>
            <span className="text-sm text-gray-400">{consultations.closed.length } استشارة</span>
          </div>
          {consultations.closed.map((c, i) => (
            <ConsultationCard key={`closed-${i}`} consultation={c} type="closed" />
          ))}
          {/* <ConsultationCard consultation={} type="closed-final" /> */}
        </div>
      </div>

      {/* Pagination */}
      <div className="flex items-center justify-between mt-6 text-sm text-gray-600">
        <div>الصفحة 1 من 10</div>
        <div className="flex items-center gap-2">
          <button className="px-2 py-1 rounded-md border border-gray-200">»</button>
          {[1, 2, 3].map((n) => (
            <button key={n} className={`px-2.5 py-1 rounded-md border ${n === 1 ? "bg-gray-900 text-white border-gray-900" : "border-gray-200"}`}>
              {n}
            </button>
          ))}
          <span className="px-2">…</span>
          <button className="px-2.5 py-1 rounded-md border border-gray-200">90</button>
          <button className="px-2 py-1 rounded-md border border-gray-200">«</button>
        </div>
      </div>
    </div>
  );
}
